export default "__VITE_ASSET__CyR32Ckl__"